// extracted by mini-css-extract-plugin
export default {"zoomModal":"u2-z","image":"v2-z","button":"w2-z","isOverlayShown":"x2-z"};